// Расширяем интерфейс Window для TypeScript
declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: {
          user?: {
            id: number
            first_name: string
            last_name?: string
            username?: string
            is_bot: boolean
          }
        }
        ready: () => void
        expand: () => void
        colorScheme: 'light' | 'dark'
        [key: string]: any
      }
    }
  }
}

export const isTelegram = (): boolean => {
  // Проверяем, что это действительно Telegram Web App, а не просто наличие объекта
  if (typeof window === 'undefined') return false;
  
  const webApp = window.Telegram?.WebApp;
  if (!webApp) return false;
  
  // Проверяем, что есть initData или что приложение действительно запущено в Telegram
  // В обычном браузере эти свойства будут undefined или пустыми
  const hasInitData = webApp.initData && webApp.initData.length > 0;
  const hasUser = webApp.initDataUnsafe?.user;
  
  // Если нет initData и нет пользователя, значит это не Telegram Mini App
  return hasInitData || !!hasUser;
};

export const getTelegramWebApp = () => {
  // Возвращаем WebApp если он существует, независимо от наличия initData
  // Это нужно для отладки - даже если initData нет, мы можем проверить другие свойства
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    return window.Telegram.WebApp;
  }
  return null;
};

export const initTelegramWebApp = () => {
  console.log('[telegram.ts] initTelegramWebApp called')
  console.log('[telegram.ts] window.Telegram:', !!window.Telegram)
  console.log('[telegram.ts] window.Telegram?.WebApp:', !!window.Telegram?.WebApp)
  
  const webApp = getTelegramWebApp();
  if (webApp) {
    console.log('[telegram.ts] Initializing Telegram WebApp...')
    console.log('[telegram.ts] WebApp properties:', {
      hasInitData: !!webApp.initData,
      initDataLength: webApp.initData?.length || 0,
      hasUser: !!webApp.initDataUnsafe?.user,
      colorScheme: webApp.colorScheme,
    })
    
    try {
      webApp.ready();
      webApp.expand();
      
      // Настройка темы
      if (webApp.colorScheme === 'dark') {
        document.documentElement.classList.add('dark');
      }
      
      console.log('[telegram.ts] Telegram WebApp initialized successfully')
      return webApp;
    } catch (error) {
      console.error('[telegram.ts] Error initializing Telegram WebApp:', error)
      return null;
    }
  }
  console.log('[telegram.ts] Not in Telegram Mini App context')
  return null;
};

export const getTelegramInitData = (): string | null => {
  const webApp = getTelegramWebApp();
  const initData = webApp?.initData;
  
  console.log('[telegram.ts] getTelegramInitData:', {
    hasWebApp: !!webApp,
    hasInitData: !!initData,
    initDataLength: initData?.length || 0,
    initDataPreview: initData ? initData.substring(0, 50) + '...' : 'null',
  });
  
  return initData || null;
};
